"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridBuilder = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var GridBlock_1 = require("../../molecules/GridBlock");
var styles_1 = __importDefault(require("./styles"));
/**
 * @deprecated
 */
var GridBuilder = function (_a) {
    var data = _a.data, marginTop = _a.marginTop, spacing = _a.spacing;
    var classes = (0, styles_1.default)({ marginTop: marginTop });
    return ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ className: classes.root }, { children: data.map(function (row) { return ((0, jsx_runtime_1.jsx)(GridBlock_1.GridBlock, { title: row.title, divider: row.divider, blockData: row.blockData, spacing: spacing, marginTop: marginTop }, "grid-block-".concat(row.title))); }) })));
};
exports.GridBuilder = GridBuilder;
